import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function oneUppercaseCharacterValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regex = new RegExp('^(?=.*[A-Z]).+$');
    const isValid = regex.test(control.value);
    return isValid ? null : { oneUppercaseCharacter: { value: control.value } };
  };
}
